import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion";
import { useLang } from "@/context/LangContext";

const CATS = [
  { name: "Philodendron", img: "/assets/p/philodendron-birkin.jpg", n: 21 },
  { name: "Anthurium", img: "/assets/p/anthurium-clarinervium.jpg", n: 8 },
  { name: "Alocasia", img: "/assets/p/alocasia-black-velvet.jpg", n: 9 },
  { name: "Aglaonema", img: "/assets/p/aglaonema-red-anjani.jpg", n: 6 },
  { name: "Begonia", img: "/assets/p/begonia-rex.jpg", n: 5 },
  { name: "Bunga Hias", en: "Flowering Plants", img: "/assets/f/bunga-kastuba-merah.webp", n: 50 },
];

export const Collections = () => {
  const { t } = useLang();
  return (
  <section data-testid="home-collections" className="bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="eyebrow">Plants Catalog 2025</p>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[0.95]">{t("Koleksi pilihan,", "Curated collections,")}<br /><span className="text-[var(--leaf)]">{t("siap tumbuh di rumahmu.", "ready to grow in your home.")}</span></h2>
        </div>
        <Link to="/katalog-tanaman" data-testid="collections-all-link" className="group inline-flex items-center gap-2 font-display text-sm font-bold text-[var(--leaf)]">
          {t("Lihat semua 137 tanaman", "See all 137 plants")} <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
        </Link>
      </Reveal>
      <div className="mt-14 -mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 sm:mx-0 sm:grid sm:grid-cols-3 sm:overflow-visible sm:px-0 lg:grid-cols-6">
        {CATS.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.07} className="w-[62%] shrink-0 snap-start sm:w-auto">
            <Link to={`/katalog-tanaman?kategori=${encodeURIComponent(c.name)}`} data-testid={`collection-${c.name.toLowerCase().replace(/\s+/g, "-")}`} className="group block">
              <div className={`relative aspect-[3/4] overflow-hidden arch ${i % 2 ? "lg:mt-14" : ""} bg-[var(--mint)]`}>
                <img src={c.img} alt={c.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-leafdeep/80 via-transparent to-transparent opacity-80" />
                <div className="absolute inset-x-4 bottom-4 text-white">
                  <p className="font-display text-lg font-black">{t(c.name, c.en)}</p>
                  <p className="text-xs text-white/85">{c.n} {t("jenis", "varieties")}</p>
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
